// extracted by mini-css-extract-plugin
module.exports = {"login":"CoursesButton_login__2yYR0","button":"CoursesButton_button__3TGWO","icon":"CoursesButton_icon__2Fij1","text":"CoursesButton_text__zkqFu"};